import { styled } from '@mui/material/styles';
import {
  Button as MuiButton
} from "@mui/material";


export const SpinnerContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  color: 'inherit',
  position: 'absolute',
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  alignItems: 'center',
  justifyContent: 'center',
}));

export const LabelContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  columnGap: theme.space._200
}));

export const CustomButton = styled(MuiButton, {
  shouldForwardProp: (prop) => true, // forwarding data attributes like data-cy TODO: refine which props to forward
})(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",

  borderRadius: "100px",
  border: "1px",

  fontWeight: theme.fontWeights.semibold,
  fontFamily: theme.fonts.default,
  textAlign: "center",
  textTransform: "none",
  lineHeight: theme.lineHeights.short,

  cursor: "pointer",

  "&:not(.is-loading).lowOpacity-disabled:disabled": {
    opacity: 0.3,
    cursor: "not-allowed",
    pointerEvents: "auto",
    color: theme.colors.black
  },

  "&:not(.is-loading):not(.lowOpacity-disabled):disabled": {
    background: theme.colors["neutral.900"],
    ".label-wrapper": {
      color: theme.colors["neutral.700"],
    },
    border: `1px solid ${theme.colors["neutral.800"]}`,
  },

  "&.is-loading": {
    pointerEvents: "auto",
    cursor: "progress",

    ".label-wrapper": {
      visibility: "hidden",
    },
  },
}));